// Pricing.jsx

import "../../styles/garage/garage-main.css";

const plans = [
    {
        name: "Monthly",
        price: "5,000",
        period: "/ month",
        description: "Flexible billing for garages getting started.",
        savings: null,
        button: "Get Started",
    },
    {
        name: "6 Months",
        price: "25,000",
        period: "/ 6 months",
        description: "A better value for growing garages.",
        savings: "Save KSh 5,000",
        button: "Choose Plan",
        featured: true,
    },
    {
        name: "Yearly",
        price: "40,000",
        period: "/ year",
        description: "The simplest way to save all year.",
        savings: "Save KSh 20,000",
        button: "Choose Plan",
    },
];

export default function Pricing() {
    return (
        <section className="garage-pricing " id="pricing">
            <div className="pricing-heading">
                

                <h2>
                    One plan for your
                    <br />
                    <span>whole garage.</span>
                </h2>

                <p>
                    No complicated tiers. Get all the tools you need to
                    manage your garage more efficiently.
                </p>
            </div>

            <div className="pricing-grid">
                {plans.map((plan) => (
                    <article
                        className={`pricing-card ${
                            plan.featured ? "featured" : ""
                        }`}
                        key={plan.name}
                    >
                        {plan.featured && (
                            <div className="popular-badge">
                                Best Offer
                            </div>
                        )}

                        <div className="pricing-card-top">
                            <span className="plan-name">{plan.name}</span>

                            {plan.savings && (
                                <span className="saving-badge">
                                    {plan.savings}
                                </span>
                            )}
                        </div>

                        <div className="price">
                            <span className="currency">KSh</span>
                            <strong>{plan.price}</strong>
                        </div>

                        <span className="price-period">
                            {plan.period}
                        </span>

                        <p>{plan.description}</p>

                        <button
                            className={`pricing-button ${
                                plan.featured ? "primary" : ""
                            }`}
                        >
                            {plan.button}
                            <span>→</span>
                        </button>
                    </article>
                ))}
            </div>

            <div className="pricing-note">
                <span>✓</span>
                All plans include every management feature.
            </div>
        </section>
    );
}